import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreatePlantPayload, Plant, User } from '@/interfaces';

import CompanyCupsForm from '../forms/CompanyCupsForm';

import usePlantForm from '../../hooks/utils/usePlantForm';

import { FormUtils } from '../../utils/form.utils';

type Props = {
  selectedCups: Plant;
  setSelectedCups: (cups: Plant | null) => void;
  companyUsers: User[];
  handleUpdatePlant: (id: number, payload: Partial<CreatePlantPayload>) => Promise<void> | void;
  companyId: number;
};

export default function UpdateCompanyCupsModal({
  selectedCups,
  setSelectedCups,
  companyUsers,
  handleUpdatePlant,
  companyId,
}: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, updateUsers, handleSubmit } = usePlantForm({
    initialState: FormUtils.getInitialStateCups(selectedCups),
    onSubmit: async (payload) => {
      await handleUpdatePlant(selectedCups.id, payload);
      setSelectedCups(null);
    },
    companyId,
  });

  return (
    <TradingModal
      titleText={t('settings.companyDetailsTab.companyCups.modal.updateCupsTitle')}
      bodyText={
        <CompanyCupsForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          companyUsers={companyUsers}
          updateField={updateField}
          updateUsers={updateUsers}
          handleSubmit={handleSubmit}
          type="update"
        />
      }
      open
      onClose={() => setSelectedCups(null)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
    />
  );
}
